import { post, get, del } from '@/api/http'
import { configNginxUrl, declareNginxUrl } from '@/api/baseUrl'

//setCookie-get
const setCookieGet = (params, config) => {
    return get(`${declareNginxUrl}/sso/setcookie`, params, config);
}

//setCookie-post
const setCookiePost = (params, config) => {
    return post(`${declareNginxUrl}/sso/setcookie`, params, config);
}

//userInfo
const getUserInfo = (params, config) => {
    return post(`${declareNginxUrl}/sso/getUserInfo`, params, config);
}

//当前企业是否维护
const isempty = (params, config) => {
    return post(`${configNginxUrl}/taxtaxpayeridentifyinfo/isempty/${params}`, config);
}

export default { setCookieGet, setCookiePost, getUserInfo, isempty }


// WEBPACK FOOTER //
// ./src/api/login/login.js